export const CopyWithJSON = element => JSON.parse(JSON.stringify(element));